import { SendHorizonal } from 'lucide-react';
import { type ReactElement } from 'react';
import { Button } from '@avanta/shared/components/ui/Button';
import { CHAT_BUTTON_INPUT_CLASSNAME } from '@avanta/shared/constants/chat';

export const SendButton = ({ disabled = false }: { disabled?: boolean }): ReactElement => (
  <Button
    variant="ghost"
    icon="only"
    type="submit"
    disabled={disabled}
    className={CHAT_BUTTON_INPUT_CLASSNAME}
  >
    <SendHorizonal className="size-4.5" />
  </Button>
);
